// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EmailController from "./email_controller"
application.register("email", EmailController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PartnershipsController from "./partnerships_controller"
application.register("partnerships", PartnershipsController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)
